import { Command, HttpMethod } from "~/extensions/api";
export class FindAddressCommand extends Command {
    constructor(postCode) {
        super(HttpMethod.Get, "common/address/find");
        this.postCode = postCode.replace("-", "");
    }
    postCode = "";
}
